import React, {FC} from 'react';
import {TransferStatusEnum} from '../../transfers/enums/TransferStatusEnum';
import Transfer from '../../transfers/types/Transfer';
import {TransferCommonDescription} from "../../transfers/types/TransferCommonDescription";
import useTranslate from "../../core/languages/hooks/useTranslate";

interface ConfirmationNumberCardProps {
  transferInfo: Transfer;
  parentTransfer?: TransferCommonDescription;
}

const ConfirmationNumberCard: FC<ConfirmationNumberCardProps> = ({transferInfo, parentTransfer}) => {
  const t = useTranslate();

  if (!parentTransfer?.id || transferInfo.status !== TransferStatusEnum.CONFIRMED) {
    return null;
  }

  return (
    <div className="mb-10">
      <div className={`bg-green-600 dark:bg-green-700 border-green-400 dark:border-green-700 rounded-2xl p-4`}>
        <div className="flex items-center space-x-2">
          <i className="las la-check-circle text-white text-3xl flex-shrink-0"></i>
          <div>
            <p className="text-xs font-medium text-white/90 uppercase tracking-wide">
              {t("transfers.fields.confirmationNumber")}
            </p>
            <p className="text-2xl font-bold text-white">
              {`#T${parentTransfer?.id}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationNumberCard;

